export default "__VITE_ASSET__IiNFk7d5__"